/**
 * RBAC frontend gates (Phase 4).
 *
 *   <Can perm="action.warroom.analyze">…</Can>   render children only if permitted
 *   <Can any={['a','b']}>…</Can>                 render if the user has ANY of the perms
 *   <RequirePermission perm="page.portfolio.view">…</RequirePermission>   route guard (redirects)
 *   usePermission('id')                          boolean hook
 *
 * All resolve through AuthContext's can(), where admin is a superuser. These mirror the
 * server-side enforcement so the UI never shows a control the API would reject.
 */
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

export function usePermission(permId) {
  const { can } = useAuth();
  return can(permId);
}

export function Can({ perm, any, children, fallback = null }) {
  const { can } = useAuth();
  const ok = any ? any.some((p) => can(p)) : can(perm);
  return ok ? children : fallback;
}

export function RequirePermission({ perm, children, redirect = '/dashboard' }) {
  const { can, loading, isAuthenticated } = useAuth();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return can(perm) ? children : <Navigate to={redirect} replace />;
}

export default Can;
